import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserModuleMutationVariables = Types.Exact<{
  module: Types.Scalars['ID']['input'];
  user: Types.Scalars['ID']['input'];
}>;


export type CreateUserModuleMutation = { __typename: 'PharosMutations', userModule_Update: { __typename: 'user_modulePayload', object: { __typename: 'UserModuleType', id: string, active: boolean, module: { __typename: 'ModuleType', id: string }, user: { __typename: 'UserType', id: string } } | null } | null };

export type RemoveUserModuleMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveUserModuleMutation = { __typename: 'PharosMutations', userModule_Update: { __typename: 'user_modulePayload', object: { __typename: 'UserModuleType', id: string, active: boolean } | null } | null };


export const CreateUserModuleDocument = gql`
    mutation createUserModule($module: ID!, $user: ID!) {
  userModule_Update(input: {module: $module, user: $user}) {
    object {
      id
      active
      module {
        id
      }
      user {
        id
      }
    }
  }
}
    `;
export type CreateUserModuleMutationFn = Apollo.MutationFunction<CreateUserModuleMutation, CreateUserModuleMutationVariables>;

/**
 * __useCreateUserModuleMutation__
 *
 * To run a mutation, you first call `useCreateUserModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserModuleMutation, { data, loading, error }] = useCreateUserModuleMutation({
 *   variables: {
 *      module: // value for 'module'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserModuleMutation, CreateUserModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserModuleMutation, CreateUserModuleMutationVariables>(CreateUserModuleDocument, options);
      }
export type CreateUserModuleMutationHookResult = ReturnType<typeof useCreateUserModuleMutation>;
export type CreateUserModuleMutationResult = Apollo.MutationResult<CreateUserModuleMutation>;
export type CreateUserModuleMutationOptions = Apollo.BaseMutationOptions<CreateUserModuleMutation, CreateUserModuleMutationVariables>;
export const RemoveUserModuleDocument = gql`
    mutation removeUserModule($id: ID!) {
  userModule_Update(input: {id: $id, active: false}) {
    object {
      id
      active
    }
  }
}
    `;
export type RemoveUserModuleMutationFn = Apollo.MutationFunction<RemoveUserModuleMutation, RemoveUserModuleMutationVariables>;

/**
 * __useRemoveUserModuleMutation__
 *
 * To run a mutation, you first call `useRemoveUserModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserModuleMutation, { data, loading, error }] = useRemoveUserModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserModuleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserModuleMutation, RemoveUserModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserModuleMutation, RemoveUserModuleMutationVariables>(RemoveUserModuleDocument, options);
      }
export type RemoveUserModuleMutationHookResult = ReturnType<typeof useRemoveUserModuleMutation>;
export type RemoveUserModuleMutationResult = Apollo.MutationResult<RemoveUserModuleMutation>;
export type RemoveUserModuleMutationOptions = Apollo.BaseMutationOptions<RemoveUserModuleMutation, RemoveUserModuleMutationVariables>;